const l = "_entityColor_1he12_1", t = "_small_1he12_5", e = "_large_1he12_8", o = "_leftIcon_1he12_12", _ = {
  entityColor: l,
  small: t,
  large: e,
  leftIcon: o
};
export {
  _ as default,
  l as entityColor,
  e as large,
  o as leftIcon,
  t as small
};
//# sourceMappingURL=index.es5493.js.map
